var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.videoPlus = {
    attach: function (context) {
      var $mlPage = $('.videos-plus-module', context);
      var $videoCta = $('.js-link--custom-get-the-look', $mlPage);
      var $slides = $('.videos-plus__slider-slide', $mlPage);
      var $carousel = $('.js-videos-plus-carousel', $mlPage);
      var $carouselContent = $('.videos-plus-module__content-container', $mlPage);
      var $carouselContentSlides = $('.videos-plus-module__content-wrap', $carouselContent);
      var $carouselPrev = $('.videos-plus-module_page_nav .previous');
      var $carouselNext = $('.videos-plus-module_page_nav .next');
      var $player = $('.video-block__media--video', $carouselContent);
      var slideToShow = window.location.href.split('#')[1];
      var $qscontainer = $('.videos-plus__content .js-quickshop-container');
      var initedCarousel = false;

      // On load hide all pages
      $carouselContentSlides.fadeOut();

      if ($slides.length < 2) {
        $carousel.hide();
      }
      var $howManySlides = $slides.length;

      $carousel.slick({
        rtl: site.direction.isRTL,
        slidesToShow: $howManySlides,
        speed: 100,
        draggable: false,
        infinite: false,
        focusOnSelect: true,
        onAfterChange: function () {
          $carouselNext.text($slides.slickCurrentSlide() + 1);
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }
        ],
        onInit: function (carousel) {
          if (initedCarousel) {
            return false;
          }
          initedCarousel = true;
          var _slideToShow = slideToShow;

          // We want to start off on a particular slide
          if (_slideToShow) {
            _slideToShow--; // The hash uses 1 as the starting index, so subtract 1 to start from 0
            var slideIndex = parseInt(_slideToShow);

            // If our hash value is a number, go to that makeup lesson slide
            // Use slick-showing to toggle opacity
            if (!isNaN(_slideToShow) && _slideToShow > 0) {
            // Not sure why this is necessary. slickGoTo would not go to the 2nd page if user lands on lesson 6
            // and lesson 6 is on page 2 of carousel
              var slidesPerPage = 3;

              if (Unison.fetch.now().name === 'medium' || Unison.fetch.now().name === 'large') {
                slidesPerPage = 5;
              }
              // How many times do we have to click the next button ?
              // Each click goes forward one slide
              var slickNextCounter = slideIndex - slidesPerPage;

              // Add one because slide 3 is on page 2, so if we want to go to slide 3 on 
              // mobile we want 0 to mean go forward one page
              if (slickNextCounter >= 0) {
                slickNextCounter++;
                for (var i = 0; i < slickNextCounter; i++) {
                // I have no idea why this wouldnt work without the setTimeout
                  setTimeout(function () {
                    $carousel.slickNext();
                  }, 400 * (i + 1));
                }
              }
              // End the manual toggling of slick pages
              $slides.eq(slideIndex).addClass('slick-showing');
              $slides.eq(slideIndex).trigger('click');
              $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
              $carouselContentSlides.eq(slideIndex).stop(true, true).fadeIn().addClass('active');
            } else {
              $slides.eq(0).addClass('slick-showing');
              $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
            }
            // Else start from first slide
          } else {
            $slides.eq(0).addClass('slick-showing');
            $carouselContentSlides.eq(0).stop(true, true).fadeIn().addClass('active');
          }
        }
      });

      // Manual changing of slide content
      $('.videos-plus__slide-wrap', $carousel).on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('slick-showing')) {
          return false;
        }
        var $activeSlide = $(this).closest('.videos-plus__slider-slide');

        $slides.not($activeSlide).removeClass('slick-showing');
        // resetting videos on change
        $('.video-block__slide').find('.active').removeClass('active').empty();
        $activeSlide.addClass('slick-showing');
        $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
        $carouselContentSlides.eq($activeSlide.index()).stop(true, true).fadeIn().addClass('active');
        $carouselContentSlides.filter('.active').find('.slick-slider').get(0).slick.setPosition();
        $qscontainer.removeClass('active active--1 active--2 active--3').hide();
      });

      // $('.videos-plus-module_page_nav .next').on('click', function(e) {
      //   e.preventDefault();
      //   // resetting videos on change
      //   $('.video-block__slide').find('.active').removeClass('active').empty();

      //   var $activeThumb = $('.videos-plus__slider-slide .slick-active');
      //   $slides.not($activeThumb).removeClass('slick-showing');
      //   // $activeThumb.addClass('slick-showing');
      //   $activeThumb.filter('.active').next().alert('poop').addClass('slick-showing').fadeIn();
      //   $carouselContentSlides.filter('.active').removeClass('active').stop(true, true).fadeOut();
      //   $carouselContentSlides.eq($activeSlide.index()).stop(true, true).fadeIn().addClass('active');
      //   // $carouselContentSlides.filter('.active').find('.slick-slider').get(0).slick.setPosition();
      //   // Close all open QS
      //   $qscontainer.removeClass('active active--1 active--2 active--3').hide();
      // });

      var $videoCarousel = $('.videos-plus-module__content-wrap');

      // mobile menu
      if ($(window).width() < 768) {
        var $menu = $('.videos-plus-module__menu', context);
        var $links = $('.videos-plus-module__content-wrap', $carousel);
        var $select = $('select.videos-plus-module__menu__selectbox', context);
        var $options = [];

        $carousel.hide();
        $menu.removeClass('hidden');

        $links.each(function () {
          var $me = $(this),
            text = $me.data('nav-description');

          $options.push('<option value="' + text + '">' + text + '</option>');
        });
        $select.append($options);
        site.util.refreshSelectBoxes($select);
        $select.change(function () {
          menuIndex = $(this).val();
          // resetting videos when carousel in action - in video_carousel_module.js
          $('.video-block__slide').find('.active').removeClass('active').empty();
          $qscontainer.removeClass('active active--1 active--2 active--3').hide();
          $videoCarousel.filter('.active').removeClass('active').stop(true, true).fadeOut();
          $('.videos-plus-module__content-container').find("[data-nav-description='" + menuIndex + "']").fadeIn().addClass('active');
        });

        function nextSlide() {
        }
      } else {
        $('.video-carousel__menu').remove();
      }

      $('.videos-plus-module_page_nav.next').click(moveForward);
      $('.videos-plus-module_page_nav.previous').click(moveBackward);

      function moveForward() {
        $(document).trigger('videoPlayerAnimate');
        var $currentSlide = $videoCarousel.filter('.active');
        var $nextSlide = $($currentSlide.closest('article').next('article').get(0) || $currentSlide.closest('article').siblings('article').first()).find('.videos-plus-module__content-wrap');
        var $thumbnails = $slides.filter(':visible');

        $currentSlide.removeClass('active').stop(true, true).fadeOut();
        $nextSlide.addClass('active').fadeIn();
        $('.video-block__slide').find('.active').removeClass('active').empty();
        $qscontainer.removeClass('active active--1 active--2 active--3').hide();
        if ($select) {
          $select.val($nextSlide.attr('data-nav-description'));
        }
        if ($thumbnails.length > 0) {
          var $currentThumbnail = $thumbnails.filter('.slick-showing');
          var $nextThumbnail = $($currentThumbnail.next().get(0) || $thumbnails.first());

          $currentThumbnail.removeClass('slick-showing');
          $nextThumbnail.addClass('slick-showing');
        }
      }
      function moveBackward() {
        $(document).trigger('videoPlayerAnimate');
        var $currentSlide = $videoCarousel.filter('.active');
        var $prevSlide = $($currentSlide.closest('article').prev('article').get(0) || $currentSlide.closest('article').siblings('article').last()).find('.videos-plus-module__content-wrap');
        var $thumbnails = $slides.filter(':visible');

        $currentSlide.removeClass('active').stop(true, true).fadeOut();
        $prevSlide.addClass('active').fadeIn();
        $('.video-block__slide').find('.active').removeClass('active').empty();
        $qscontainer.removeClass('active active--1 active--2 active--3').hide();
        if ($select) {
          $select.val($prevSlide.attr('data-nav-description'));
        }
        if ($thumbnails.length > 0) {
          var $currentThumbnail = $thumbnails.filter('.slick-showing');
          var $prevThumbnail = $($currentThumbnail.prev().get(0) || $thumbnails.last());

          $currentThumbnail.removeClass('slick-showing');
          $prevThumbnail.addClass('slick-showing');
        }
      }

      isTouch = Modernizr.touch;
      if (isTouch) {
        (function (factory) {
          if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define(['jquery'], factory);
          } else if (typeof exports === 'object') {
            // Node/CommonJS
            module.exports = factory(require('jquery'));
          } else {
            // Browser globals
            factory(jQuery);
          }
        }(function ($) {
          $.detectSwipe = {
            enabled: 'ontouchstart' in document.documentElement,
            preventDefault: true,
            threshold: 20
          };

          var startX,
            startY,
            isMoving = false;

          function onTouchEnd() {
            this.removeEventListener('touchmove', onTouchMove);
            this.removeEventListener('touchend', onTouchEnd);
            isMoving = false;
          }

          function onTouchMove(e) {
            if (isMoving) {
              var x = e.touches[0].pageX;
              var y = e.touches[0].pageY;
              var dx = startX - x;
              var dy = startY - y;
              var dir;
              var ratio = window.devicePixelRatio || 1;

              if (Math.abs(dx) * ratio >= $.detectSwipe.threshold) {
                dir = dx > 0 ? 'left' : 'right';
              } else if (Math.abs(dy) * ratio >= $.detectSwipe.threshold) {
                dir = dy > 0 ? 'up' : 'down';
              }
              if (dir) {
                if ($.detectSwipe.preventDefault && (dir === 'left' || dir === 'right')) {
                  e.preventDefault();
                }
                onTouchEnd.call(this);
                $(this).trigger('swipe', dir).trigger('swipe' + dir);
              }
            }
          }

          function onTouchStart(e) {
            if (e.touches.length === 1) {
              startX = e.touches[0].pageX;
              startY = e.touches[0].pageY;
              isMoving = true;
              this.addEventListener('touchmove', onTouchMove, false);
              this.addEventListener('touchend', onTouchEnd, false);
            }
          }

          function setup() {
            this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
          }

          function teardown() {
            this.removeEventListener('touchstart', onTouchStart);
          }

          $.event.special.swipe = { setup: setup };

          $.each(['left', 'up', 'down', 'right'], function () {
            $.event.special['swipe' + this] = {
              setup: function () {
                $(this).on('swipe', $.noop);
              }
            };
          });
        }));

        $('.videos-plus__content')
          .on('swipeleft', moveForward)
          .on('swiperight', moveBackward);
      }
    }
  };
})(jQuery);
